<div class="sensitive-container">
    <!-- Exiting scss 'sensitive-button-old' with feature flag. Should be removed when third party consent feature is fully implemented -->
    <div class="sensitive-button" [ngClass]="{'sensitive-button-active': sensitiveInformation === SensitiveTypeEnum.SENSITIVE, 'sensitive-button-old': thirdPartyConsentActive === false}" (click)="clickSensitive()" >
        <span *ngIf="sensitiveInformation === SensitiveTypeEnum.SENSITIVE">Case is sensitive</span>
        <span *ngIf="sensitiveInformation === SensitiveTypeEnum.NOT_SENSITIVE || !sensitiveInformation">Case is not sensitive</span>
    </div>
</div>
